var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardScreenGreenStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5811 21.0742C11.3319 21.7357 10.2356 21.7357 9.98649 21.0742C9.2639 19.1533 8.08015 16.5329 6.55877 15.0115C5.03744 13.4902 2.41689 12.3062 0.496475 11.5838C-0.165491 11.3346 -0.165491 10.2384 0.496475 9.98925C2.41689 9.26683 5.03744 8.08291 6.55877 6.56153C8.08015 5.04014 9.2639 2.41977 9.98649 0.499461C10.2356 -0.162618 11.3319 -0.162618 11.5811 0.499461C12.3035 2.41977 13.4874 5.04014 15.0088 6.56153C16.5302 8.08291 19.1505 9.26683 21.0714 9.98925C21.7329 10.2384 21.7329 11.3346 21.0714 11.5838C19.1505 12.3062 16.5302 13.4902 15.0088 15.0115C13.4874 16.5329 12.3035 19.1533 11.5811 21.0742Z",
    fill: "#C1F700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardScreenGreenStar);
export default __webpack_public_path__ + "static/media/dashboard-screen-green-star.105c3d921b18ce4acec592f1bfbdffb7.svg";
export { ForwardRef as ReactComponent };